import React from "react";
import { useNavigate } from "react-router-dom";

// Единая панель вкладок на весь раздел Prom -- рендерится и на
// /integrations/prom (Общие настройки/Отправители/Выгрузка/Заказы -- локальные),
// и на /integrations/prom/mappings|attributes (переход как обычная навигация,
// с передачей текущего аккаунта через ?account=, чтобы не переспрашивать его
// повторно). Устроена так же, как RozetkaTopBar.
const ITEMS = [
    { key: "general", label: "Общие настройки", path: "/integrations/prom" },
    { key: "senders", label: "Отправители Prom", path: "/integrations/prom" },
    { key: "export", label: "Выгрузка и цены", path: "/integrations/prom" },
    { key: "pricing", label: "Цены", path: "/integrations/prom" },
    { key: "orders", label: "Настройка заказов", path: "/integrations/prom" },
    { key: "mapping", label: "Маппинг категорий", path: "/integrations/prom/mappings" },
    { key: "attributes", label: "Характеристики Prom", path: "/integrations/prom/attributes" },
];

const PromTopBar = ({ activeKey, accountId, localKeys, onLocalSelect }) => {
    const navigate = useNavigate();

    return (
        <div className="ip-tabbar">
            {ITEMS.map((item) => {
                const isLocal = localKeys.includes(item.key);
                const isActive = activeKey === item.key;
                const goToOtherPage = () => {
                    const params = new URLSearchParams();
                    if (accountId) params.set("account", accountId);
                    const query = params.toString();
                    navigate(query ? `${item.path}?${query}` : item.path);
                };
                return (
                    <button
                        key={item.key}
                        type="button"
                        className={isActive ? "ip-tab active" : "ip-tab"}
                        disabled={!isLocal && !accountId}
                        onClick={isLocal ? () => onLocalSelect(item.key) : goToOtherPage}
                    >
                        {item.label}
                    </button>
                );
            })}
        </div>
    );
};

export default PromTopBar;
